import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskCandidateAnonymized_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskCandidateAnonymized_ActivityLogFragment;
}

const ActivityLogTaskCandidateAnonymized: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.anonymizedCandidate"
    />
  );
};

ActivityLogTaskCandidateAnonymized.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskCandidateAnonymized_activityLog on ActivityLog {
      id
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskCandidateAnonymized;
